import React, { useEffect, useState, useContext, Fragment } from "react"
import { RootContext } from 'RootContext';

// Core components
import Box from "@material-ui/core/Box"
import CircularProgress from "@material-ui/core/CircularProgress"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import FileSaver from "file-saver"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { DropzoneArea } from "material-ui-dropzone"
import CardBody from "components/Card/CardBody.js"
import Button from "@material-ui/core/Button"


import { Stage, Layer, Line } from "react-konva"

// Pegaso components
import CompressUtils from "components/Tools/CompressUtils"
import JobUtils from "components/Utils/JobUtils"
import JobFrame from "views/Job/JobFrameCatalogue/JobFrame"
import JobLoadedShape from "views/Job/JobLoadedShape/JobLoadedShape"
import OmaUtils from "components/Utils/OmaUtils"
import ShapeBar from "views/Shape/ShapeBar"
import ShapeModify from "views/Shape/ShapeModify"
import ShapeUtils from "components/Utils/ShapeUtils"
import Tracer from "views/Tracer/Tracer"
import cartaMMImage from "assets/img/CartaMM.png"

// Css
import { useShapeStyle, useShapeStyleGrids } from "styles/shape/shapeCss"
import DrillsManagement from "views/DrillsManagement/DrillsManagement"
import Drills from "components/Drills/Drills"
import ShapeEdit from "components/Shape/ShapeEdit"
import { useDropzoneAreaStyle } from "styles/autocadConverter/autocadConverterCss"

export default function ShapeReduced(props) {
  // Compontents of table
  const {
    shape,
    edgingData,
    frameBrandsFilterOption,
    frameSuppliersFilterOption,
    scaleX,
    scaleY,
    editMode,
    isGlasant,
    jobId,
    offset,
    handleDrillChange,
    handleUpdateEdgingData,
  } = props
  const classes = useShapeStyleGrids()
  const dropzoneClasses = useDropzoneAreaStyle()
  const {
    t,
    apiUrlPegasoTools,
    userDevice,
    getCalibration,
    getPrecalibrationActive,
    getFrameManagementActive,
    access_token_pegaso_tools,
    refresh_token_pegaso_tools,
    setAccess_token_pegaso_tools,
    companyId
  } = useContext(RootContext)
  const frameManagementActive = getFrameManagementActive()
  const shapeClass = useShapeStyle.shape
  const [shapeJson, setShapeJson] = useState()
  const [shapeModifyJson, setShapeModifyJson] = useState()
  const [shapeExists, setShapeExists] = useState(editMode ? false : true)
  const [shapeIncorrect, setShapeIncorrect] = useState(false)
  const canvasHeight = 350
  const canvasWidth = 800
  const [startRightLens, setStartRightLens] = useState(250)
  const originY = 150
  const [openDrillsManagement, setOpenDrillsManagement] = useState(false)
  const [openShapeModify, setOpenShapeModify] = useState(false)
  const [openUpload, setOpenUpload] = useState(false)
  const [openLoadedShape, setOpenLoadedShape] = useState(false)
  const [openTracer, setOpenTracer] = useState(false)
  const [openFrame, setOpenFrame] = useState(false)
  const [calibration] = useState(getCalibration())
  const [currentShape, setCurrentShape] = useState("")
  const [currentEdgingData, setCurrentEdgingData] = useState(edgingData)
  const [wrongFormatFile, setWrongFormatFile] = useState(false)
  const [fileChargedData, setFileChargedData] = useState([])
  const [device] = useState(userDevice)
  const [cartaMMBackground] = React.useState(cartaMMImage)
  var sizeCartaMM = (3800 / calibration.dpiX) + "px";
  const [startLeftLens, setStartLeftLens] = useState(0)
  const precalibrationActive = getPrecalibrationActive()

  const origin = { x: startRightLens, y: originY }
  useEffect(() => {
    setCurrentShape(JobUtils.GetStandardShape({ shape: { standard: shape } }))
    setCurrentEdgingData(edgingData)
  }, [shape, edgingData])




  useEffect(() => {
    const shapeToDraw = ShapeUtils.extractShapeFromOMA(
      currentShape,
      currentEdgingData,
      scaleX,
      scaleY,
      offset,
      calibration
    )
    if (shapeToDraw !== undefined) {
      setShapeJson(shapeToDraw)
      var rightHbox = shapeToDraw.right.hbox ? shapeToDraw.right.hbox : 55
      var leftHbox = shapeToDraw.left.hbox ? shapeToDraw.left.hbox : 55
      setStartRightLens(
        canvasWidth / 2 - (shapeToDraw.dbl * 50 / 25 + rightHbox * 50 / 25)
      )
      setStartLeftLens(
        canvasWidth / 2 + (shapeToDraw.dbl * 50 / 25 + leftHbox * 50 / 25)
      )
      if (
        shapeToDraw.right.points.length > 1 ||
        shapeToDraw.left.points.length > 1
      ) {
        setShapeExists(true)
      } else {
        setShapeExists(false)
      }

    }
    else {
      setShapeIncorrect(true)
      setCurrentShape("")
    }

  }, [
    calibration,
    currentShape,
    shape,
    edgingData,
    currentEdgingData,
    scaleX,
    scaleY,
    offset,
  ])

  function handleFileUpload() {
    var files = fileChargedData
    if (files.length > 0) {
      const reader = new FileReader()
      reader.readAsText(files[0])
      reader.onload = function () {
        const { result } = reader
        const fileShape = result
        var tracerDataConverted = OmaUtils.ConvertDataToOma(apiUrlPegasoTools, access_token_pegaso_tools, refresh_token_pegaso_tools, setAccess_token_pegaso_tools,
          fileShape, 3, companyId)
        tracerDataConverted.then(function (result) {
          var dataToOma = result
          if (dataToOma.length === 2) {
            if (
              dataToOma[0].trim() !== "" ||
              dataToOma[1].trim() !== ""
            ) {
              setWrongFormatFile(false)
              const standardShape = dataToOma[0].trim()
              const edgingData = dataToOma[1]
              handleUpdateShape(fileShape, standardShape, edgingData, false)
            } else {
              setWrongFormatFile(true)
            }
          } else {
            setWrongFormatFile(true)
          }
        })
      }
      setOpenUpload(false)
    }
  }

  function handleUpdateShape(
    originalShape,
    standardShape,
    edgingData,
    hasDeviceUploader = false
  ) {
    var originalShapeCompressed = CompressUtils.zlibCompress(originalShape)
    var standardShapeCompressed = CompressUtils.zlibCompress(standardShape)

    setCurrentShape(
      JobUtils.GetStandardShape({
        shape: {
          original: originalShapeCompressed,
          standard: standardShapeCompressed,
        },
      })
    )
    var newEdgingData = OmaUtils.ExtractOmaLabelWithValue(edgingData, ["HBOX", "VBOX", "DBL", "DRILL", "DRILLE", "ETYP", "FTYP", "BEVP", "BEVM", "GWIDTH", "GDEPTH"])

    handleUpdateEdgingData(
      standardShapeCompressed,
      newEdgingData,
      originalShapeCompressed,
      hasDeviceUploader
    )
  }

  function handleFrameUpload(
    originalShape,
    standardShape,
    edgingData,
    hasDeviceUploader = false
  ) {
    setCurrentShape(
      JobUtils.GetStandardShape({
        shape: {
          original: originalShape,
          standard: standardShape,
        },
      })
    )
    setCurrentEdgingData(edgingData)
    handleUpdateEdgingData(
      standardShape,
      edgingData,
      originalShape,
      hasDeviceUploader
    )
  }

  function handleTracerOpenClick() {
    setOpenTracer(true)
  }

  function handleFrameClick() {
    setOpenFrame(true)
  }

  function handleClickCloseFrame() {
    setOpenFrame(false)
  }

  function handleTracerCloseClick() {
    setOpenTracer(false)
  }

  function handleExportClick() {
    var shapeDataConverted = JobUtils.convertShapeToExport(currentShape)
    var blob = new Blob([`${shapeDataConverted}\r\n${edgingData}`], {
      type: "text/plain;charset=utf-8",
    })
    if (jobId) {
      FileSaver.saveAs(blob, `job_${jobId}.txt`)
    } else {
      FileSaver.saveAs(blob, `job_new.txt`)
    }
  }

  function handleImportClick() {
    setOpenUpload(true)
  }


  function handleDeleteShapeClick() {
    let newLine = "\r\n"
    let cleanEdgingData = ""
    setCurrentShape("")
    // 2020/06/30 - Tolgo i vecchi drillingPoints (se ci sono)
    cleanEdgingData =
      edgingData.indexOf("DRILL") >= 0
        ? OmaUtils.RemoveOmaLabel(edgingData.split(newLine), "DRILL").join(
          newLine
        )
        : edgingData
    handleUpdateEdgingData("", cleanEdgingData, "", false)
    setOpenTracer(false)
  }

  function handleModifyShapeClick() {
    setOpenShapeModify(true)
  }

  function NoShape({ shapeExists }) {
    return (
      <div>
        {!shapeExists ? (
          <u>
            <strong>{t("10083").toUpperCase()}</strong>
          </u>
        ) : null}
      </div>
    )
  }

  function IncorrectShape({ shapeIncorrect }) {
    return (
      <div>
        {shapeIncorrect ? (
          <strong style={{ color: 'red' }}>{t("10476").toUpperCase()}</strong>
        ) : null}
      </div>
    )
  }

  function NoTracer({ deviceExists }) {
    return (
      <div>
        {!deviceExists ? (
          <u>
            <strong>{t("22").toUpperCase()}</strong>
          </u>
        ) : null}
      </div>
    )
  }


  /**
   * 
   * 
   * FUNZIONI GESTIONE FORI
   * 
   * 
   */

  //Apre la pagina di gestione dei fori
  function handleOpenDialogDrill() {
    setOpenDrillsManagement(true)
  }

  //Restituisce un booleano per l'abilitazione bottone fori
  function disableDrillButton() {
    if (isGlasant) {
      return false
    }
    return true
  }

  //Sposta un foro
  const onDragEnd = e => {
    const id = parseFloat(e.target.name().split("_")[3]);
    var drillPoints = shapeJson.drillingPoints
    var newX = 0
    drillPoints = drillPoints.map((drill) => {
      if (drill.id === id) {
        if (e.target.name().indexOf("left") >= 0) {
          newX = parseFloat(((startLeftLens - e.target.x()) / scaleX).toFixed(2))
        }
        else if (e.target.name().indexOf("right") >= 0) {
          newX = parseFloat(((e.target.x() - origin.x) / scaleX).toFixed(2))
        }
        var newY = parseFloat(((origin.y - e.target.y()) / scaleY).toFixed(2));
        var diam = parseFloat(drill.diam).toFixed(2)
        drill = { ...drill, xStart: newX, yStart: newY, diam: diam }
      }
      return drill
    })
    setShapeJson({ ...shapeJson, "drillingPoints": drillPoints })
  };

  //Aggiunge un foro cliccando
  const onClickStage = e => {
    if (openDrillsManagement) {
      const stage = e.target.getStage();
      const stageLocation = stage.getPointerPosition();
      var newX = 0
      if (stageLocation.x > canvasWidth / 2) {
        newX = parseFloat(((startLeftLens - stageLocation.x) / scaleX).toFixed(2))
      }
      else {
        newX = parseFloat(((stageLocation.x - origin.x) / scaleX).toFixed(2))
      }
      var newY = parseFloat(((origin.y - stageLocation.y) / scaleY).toFixed(2));
      handleAddDrill(newX, newY)
    }
  }

  //Aggiunge un foro
  function handleAddDrill(newX, newY, diam = 1.00) {
    var drillPoints = shapeJson.drillingPoints
    let maxId = 0;
    drillPoints.forEach(drill => {
      if (drill.id > maxId) {
        maxId = drill.id;
      }
    });
    if (maxId < 10) {
      setShapeJson({ ...shapeJson, "drillingPoints": [...drillPoints, { id: maxId + 1, xStart: newX, yStart: newY, diam: diam, isSlot: false, side: "B" }] })
    }
  }

  /**
     * 
     * 
     * FUNZIONI GESTIONE DROPZONE AREA INSERIMENTO FILE
     * 
     * 
     */

  //Handler change del file inserito
  function handleChangeFile(files) {
    setFileChargedData(files)
  }

  // Click Close Dialog
  function handleClickClose() {
    setOpenUpload(false)
    setFileChargedData([])
  }

  function handleLoadedClick() {
    setOpenLoadedShape(true)
  }

  function handleLoadedCloseClick() {
    setOpenLoadedShape(false)
  }


  return (
    <div >
      {/* POPUP - UPLOAD */}

      <Fragment>
        <Dialog
          open={openUpload}
          fullWidth
          maxWidth="sm"
          onClose={handleClickClose}
        >
          <CardBody>
            <h4><strong>Upload File</strong></h4>
            <DropzoneArea
              acceptedFiles={['.oma', '.dat', '.txt']}
              dropzoneClass={dropzoneClasses.myDropZone}
              dropzoneParagraphClass={dropzoneClasses.dropZoneText}
              dropzoneText={t("10386")}
              filesLimit={1}
              onChange={handleChangeFile.bind(this)}
              maxFileSize={10000000}
              useChipsForPreview={true}
            />
            <Box
              m={1}
              display="flex"
              justifyContent="flex-end"
            >
              <Button
                variant="outlined"
                color="secondary"
                style={{ border: 'none' }}
                onClick={handleClickClose}
              >
                {t("10407")}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                style={{ border: 'none', align: 'right' }}
                onClick={handleFileUpload}
                disabled={!fileChargedData.length > 0}
              >
                {t("10408")}
              </Button>
            </Box>
          </CardBody>
        </Dialog>
      </Fragment>

      <Box
        display="flex"
        justifyContent="flex-end"
        width="100%"
        flexDirection="column"
      >
        < Box p={1}>
          {/* BUTTONS */}
          <ShapeBar
            currentShape={currentShape}
            device={device}
            disableDrillButton={disableDrillButton}
            frameManagementActive={frameManagementActive}
            handleFrameClick={handleFrameClick}
            handleTracerClick={handleTracerOpenClick}
            handleImportClick={handleImportClick}
            handleExportClick={handleExportClick}
            handleDeleteShapeClick={handleDeleteShapeClick}
            handleModifyShapeClick={handleModifyShapeClick}
            handleOpenDialogDrill={handleOpenDialogDrill}
            handleLoadedClick={handleLoadedClick}
            openDrillsManagement={openDrillsManagement}
            openShapeModify={openShapeModify}
            openTracer={openTracer}
            showBar={true}
            showImport={true}
          />
        </Box>

        {shapeIncorrect ? <Grid container spacing={2}>
          <Grid align="center" item xs={12}>
            <IncorrectShape shapeIncorrect={shapeIncorrect} />
          </Grid>
        </Grid> : null}

        {/* DISEGNO */}
        <Box p={1} alignSelf="center">
          {!openTracer && currentShape ? (
            <div>
              <Stage
                width={canvasWidth}
                height={canvasHeight}
                style={(!disableDrillButton() && openDrillsManagement) || openShapeModify ? { backgroundImage: "url(" + cartaMMBackground + ")", backgroundSize: sizeCartaMM } : null}
                onClick={onClickStage}
              >
                {/* DISEGNO FORMA (BLU) */}
                {shapeExists && !openDrillsManagement ? (
                  <Layer>
                    {/* 1 - LENTE DESTRA (origine = centro lente) */}
                    <Line
                      closed
                      fill={!openShapeModify ? shapeClass.fill : null}
                      points={shapeJson ? shapeJson.right.points : []}
                      stroke={!openShapeModify ? shapeClass.stroke : 'blue'}
                      strokeWidth={shapeClass.strokeWidth}
                      tension={0}
                      x={origin.x}
                      y={origin.y}
                    />
                    {/* FORI (Lente Destra) */}
                    <Drills
                      onDragEnd={onDragEnd}
                      openDrillsManagement={openDrillsManagement}
                      origin={origin}
                      scaleX={scaleX}
                      scaleY={scaleY}
                      shapeJson={shapeJson}
                      shapeClass={shapeClass}
                      startLens={origin.x}
                      side={"right"}
                      stroke={!openShapeModify ? shapeClass.stroke : 'blue'}
                    />
                    { }
                    {/* 2 - LENTE SINISTRA (origine = centro lente) */}
                    <Line
                      closed
                      fill={!openShapeModify ? shapeClass.fill : null}
                      points={shapeJson ? shapeJson.left.points : []}
                      tension={0}
                      stroke={!openShapeModify ? shapeClass.stroke : 'blue'}
                      strokeWidth={shapeClass.strokeWidth}
                      x={startLeftLens}
                      y={origin.y}
                    />
                    {/* FORI (Lente Sinistra) */}
                    <Drills
                      onDragEnd={onDragEnd}
                      openDrillsManagement={openDrillsManagement}
                      origin={origin}
                      scaleX={scaleX}
                      scaleY={scaleY}
                      shapeJson={shapeJson}
                      shapeClass={shapeClass}
                      startLens={startLeftLens}
                      side={"left"}
                      stroke={!openShapeModify ? shapeClass.stroke : 'blue'}
                    />
                  </Layer>
                ) : null}

                {/* DISEGNO FORI FORMA (ROSSO) */}
                {
                  shapeExists && openDrillsManagement ? (
                    <ShapeEdit
                      isDraggable={true}
                      origin={origin}
                      openDialog={openDrillsManagement}
                      onDragEnd={onDragEnd}
                      scaleX={scaleX}
                      scaleY={scaleY}
                      shapeClass={shapeClass}
                      shapeJson={shapeJson}
                      startLeftLens={startLeftLens}
                      stroke={'red'}
                    />
                  ) : null
                }

                {/* DISEGNO MODIFICA FORMA (ROSSO) */}
                {
                  shapeExists && openShapeModify && shapeModifyJson ? (
                    <ShapeEdit
                      openDialog={openShapeModify}
                      origin={origin}
                      scaleX={scaleX}
                      scaleY={scaleY}
                      shapeJson={shapeModifyJson}
                      shapeClass={shapeClass}
                      startLeftLens={startLeftLens}
                      stroke={'red'}
                    />
                  ) : null
                }
              </Stage>

            </div>

          ) : null}
        </Box>

        {/* ERRORE - UPLOAD */}
        {
          wrongFormatFile ?
            <Box p={1} alignSelf="flex-end">
              <Typography align="right" color="error">
                {t("10151")}
              </Typography>
            </Box> : null
        }
      </Box>

      {/* POPUP - TRACER */}
      {
        openTracer ? (
          device ? (
            <Tracer
              handleUpdateShape={handleUpdateShape}
              handleClose={handleTracerCloseClick}
            />
          ) : (
            <Grid container spacing={2}>
              <Grid align="center" item xs={12}>
                <NoTracer deviceExists={device} />
              </Grid>
            </Grid>
          )
        ) : (
          <Grid container spacing={2}>
            <Grid align="center" item xs={12}>
              <NoShape shapeExists={shapeExists} />
            </Grid>
          </Grid>
        )
      }

      {/*GESTIONE FORI*/}
      {
        openDrillsManagement ? (
          <div className={classes.shapeDrillGrid}>
            <DrillsManagement
              {...props}
              classes={classes}
              currentEdgingData={currentEdgingData}
              currentShape={currentShape}
              handleAddDrill={handleAddDrill}
              handleDrillChange={handleDrillChange}
              openCard={openDrillsManagement}
              scaleX={scaleX}
              scaleY={scaleY}
              setOpenDrillsManagement={setOpenDrillsManagement}
              setShapeJson={setShapeJson}
              shapeJson={shapeJson}
            />
          </div>) : (null)
      }

      {/*MODIFICA FORMA*/}
      {
        openShapeModify ? (
          <div className={classes.shapeModifyGrid}>
            <ShapeModify
              {...props}
              calibration={calibration}
              edgingData={edgingData}
              handleUpdateShape={handleUpdateShape}
              scaleX={scaleX}
              scaleY={scaleY}
              setWrongFormatFile={setWrongFormatFile}
              shapeJson={shapeJson}
              shapeModifyJson={shapeModifyJson}
              setOpenShapeModify={setOpenShapeModify}
              setShapeModifyJson={setShapeModifyJson}
            />
          </div>) : (null)
      }


      {/*INSERIMENTO MONTATURA DA CATALOGO*/}
      {
        frameManagementActive && openFrame ? (
          <div>
            <Dialog
              onClose={handleClickCloseFrame}
              aria-labelledby="customized-dialog-title"
              open={openFrame}
              maxWidth="xl"
            >
              <DialogContent>
                {
                  frameBrandsFilterOption.length > 0 && frameSuppliersFilterOption.length > 0 ?
                    <JobFrame
                      frameBrands={frameBrandsFilterOption}
                      frameSuppliers={frameSuppliersFilterOption}
                      handleFrameUpload={handleFrameUpload}
                      setOpenFrameList={setOpenFrame}
                      onHandleClose={handleClickCloseFrame}
                    />
                    :
                    <CircularProgress size={42} style={{ color: "primary" }} />
                }
              </DialogContent>
            </Dialog>
          </div>
        ) : (
          null
        )
      }

      {/*INSERIMENTO MONTATURA DA PRECARICATE*/}
      {
        precalibrationActive && openLoadedShape ? (
          <div>
            <Dialog
              onClose={handleClickCloseFrame}
              aria-labelledby="customized-dialog-title"
              open={openLoadedShape}
              maxWidth="xl"
            >
              <DialogContent>
                <JobLoadedShape
                  handleFrameUpload={handleFrameUpload}
                  onHandleClose={handleLoadedCloseClick}
                  setOpenLoadedShape={setOpenLoadedShape}
                />
              </DialogContent>
            </Dialog>
          </div>
        ) : (
          null
        )
      }


    </div >
  )
}
